import { EPerformanceEvaluationStatus } from '@common/definitions';
import React from 'react';

interface StatusChipProps {
  status: string;
}

const StatusChip: React.FC<StatusChipProps> = ({ status }) => {

  const getStatusClasses = (evaluationStatus?: EPerformanceEvaluationStatus) => {
    const baseClasses = 'tw-w-2 tw-h-2 tw-rounded-full tw-shadow-sm';

    switch (evaluationStatus) {
      case EPerformanceEvaluationStatus.STARTED:
        return `${baseClasses} !tw-bg-gray-custom-100`;
      case EPerformanceEvaluationStatus.SUBMITTED:
        return `${baseClasses} !tw-bg-blue-brand`;
      case EPerformanceEvaluationStatus.FINISHED:
        return `${baseClasses} !tw-bg-green-500`;
      default:
        return `${baseClasses} !tw-bg-gray-100`;
    }
  };

  return (
    <div className="tw-flex tw-justify-center">
      <div
        className="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2
      tw-rounded-[25px] tw-border tw-border-solid tw-border-gray-border"
      >
        <div className={getStatusClasses(status as EPerformanceEvaluationStatus)} />
        <span className="tw-text-sm tw-font-medium tw-capitalize tw-font-inter tw-text-gray-text">
          {status}
        </span>
      </div>
    </div>
  );
};

export default StatusChip;
